export default {
  install(Vue, options) {
    Object.defineProperty(Vue.config.globalProperties, '$subscription', {
      get() {
        return this.$store.getters['subscriptions/currentSubscription']
      }
    })
  }
}
